import { ADD_BREADCRUMB, REMOVE_BREADCRUMB, RESET_BREADCRUMBS, SET_BREADCRUMBS } from 'reducers/actions-types';
import t from 'translations';
import linkToHome from 'util/misc/link-to-home';

export default {
    /**
     * Add breadcrumb entry
     * @param {IBreadcrumb} breadcrumb
     * @return {{breadcrumb: *, type: *}}
     */
    add({ breadcrumb }) {
        return { type: ADD_BREADCRUMB, breadcrumb };
    },

    /**
     * Set breadcrumbs
     * @param {IBreadcrumb[]} breadcrumbs
     * @return {{type: *, breadcrumbs: *}}
     */
    set({ breadcrumbs }) {
        return { type: SET_BREADCRUMBS, breadcrumbs };
    },

    /**
     * Remove specific breadcrumb
     * @param {IBreadcrumb} breadcrumb
     * @return {{breadcrumb: *, type: *}}
     */
    remove({ breadcrumb }) {
        return { type: REMOVE_BREADCRUMB, breadcrumb };
    },

    reset() {
        return { type: RESET_BREADCRUMBS };
    },

    /**
     * Setting smart back action
     * @param {IBreadcrumb} data
     * @return {Function}
     */
    setSmartBack(data = {}) {
        return function(dispatch, getState) {
            const { lastRoute } = getState().router;
            const breadcrumb = {};

            if (lastRoute) {
                Object.assign(breadcrumb, {
                    name: lastRoute.meta.menu_title,
                    url: lastRoute.location.pathname,
                }, data);
            } else {
                Object.assign(breadcrumb, {
                    name: t('breadcrumbs.overview'),
                    url: linkToHome(getState().region.active),
                }, data);
            }

            dispatch({ type: SET_BREADCRUMBS, breadcrumbs: [breadcrumb] });
        };
    },
};




// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/reducers/modules/breadcrumbs/actions.js